import { __rest } from 'tslib';
import React, { useState, useMemo, useEffect } from 'react';
import mockRegions from '../../../mocks/mockRegions.mjs';
import HorizontalList from '../../Basic/Lists/HorizontalList/HorizontalList.mjs';
import DesktopOnly from '../../Containers/DesktopOnly/DesktopOnly.mjs';
import MobileOnly from '../../Containers/MobileOnly/MobileOnly.mjs';
import BottomLinks from '../../UIElements/BottomLinks/BottomLinks.mjs';
import DesktopNavigation from '../../UIElements/MainMenu/DesktopNavigation.mjs';
import TopNavigation from '../../UIElements/TopNavigation/TopNavigation.mjs';
import MobileNavigation from '../NavigationSidebar/MobileNavigation.mjs';
import { NavigationContainer, NavigationSlideAnimation } from './Navigation.styles.mjs';
import { useTheme } from 'styled-components';

const Navigation = (_a) => {
    var { menu, secondaryMenu, region, newsletter, searchProps } = _a, topNavigationProps = __rest(_a, ["menu", "secondaryMenu", "region", "newsletter", "searchProps"]);
    const theme = useTheme();
    const [isOpen, setIsOpen] = useState(false);
    const handleBurgerButtonClick = () => setIsOpen(open => !open);
    const mobileRegionSelectorProps = useMemo(() => ({
        onSelect: region.onChange,
        selectedRegion: region.selectedRegion,
        regionSelectionModalProps: {
            selectedRegion: region.selectedRegion,
            heading: region.heading,
            regions: mockRegions
        }
    }), [region]);
    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'unset';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);
    return (React.createElement(NavigationContainer, { open: isOpen },
        React.createElement(DesktopOnly, null,
            React.createElement(BottomLinks, { options: secondaryMenu })),
        React.createElement(TopNavigation, Object.assign({ region: region, isOpen: isOpen, burgerButtonProps: { isOpen, onClick: handleBurgerButtonClick }, searchProps: searchProps }, topNavigationProps)),
        !isOpen && (React.createElement(MobileOnly, { breakpoint: theme.breakpoints.xl },
            React.createElement(HorizontalList, Object.assign({}, topNavigationProps.horizontalListProps)))),
        React.createElement(DesktopOnly, null,
            React.createElement(NavigationSlideAnimation, { open: isOpen },
                React.createElement(DesktopNavigation, { menu: menu, newsletter: newsletter, region: region }))),
        React.createElement(MobileOnly, null,
            React.createElement(NavigationSlideAnimation, { open: isOpen },
                React.createElement(MobileNavigation, { menu: menu, secondaryMenu: secondaryMenu, regionSelectorProps: mobileRegionSelectorProps, searchProps: searchProps, newsletter: newsletter })))));
};

export { NavigationContainer, NavigationSlideAnimation, Navigation as default };
//# sourceMappingURL=Navigation.mjs.map
